export default __webpack_public_path__ + "static/media/oups.d62386b3.png";